export const trackingEventAutoLayout = "autoLayoutError";
//# sourceMappingURL=auto_layout.js.map